import { Buffer } from 'buffer';

export default (prefix: string | null = null): string => {
  const randomId = Buffer
    .from(JSON.stringify(Math.random() * 999999999 - Math.random() * 99999999), 'utf-8')
    .toString('base64');

  return `${prefix || ''}${randomId}`;
};
